import { render } from "./addressErrList.vue?vue&type=template&id=38cc780d&scoped=true"
import script from "./addressErrList.vue?vue&type=script&lang=js"
export * from "./addressErrList.vue?vue&type=script&lang=js"

import "./addressErrList.vue?vue&type=style&index=0&id=38cc780d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-38cc780d"

export default script